// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReasonCodeResponseDto
 */
export interface IReasonCodeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IReasonCodeResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReasonCodeResponseDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IReasonCodeResponseDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IReasonCodeResponseDto interface.
 */
export function instanceOfIReasonCodeResponseDto(value: object): value is IReasonCodeResponseDto {
    return true;
}

export function IReasonCodeResponseDtoFromJSON(json: any): IReasonCodeResponseDto {
    return IReasonCodeResponseDtoFromJSONTyped(json, false);
}

export function IReasonCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReasonCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IReasonCodeResponseDtoToJSON(json: any): IReasonCodeResponseDto {
    return IReasonCodeResponseDtoToJSONTyped(json, false);
}

export function IReasonCodeResponseDtoToJSONTyped(value?: IReasonCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'description': value['description'],
    };
}

